var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7929 11.2929C19.7357 10.3501 21.2643 10.3501 22.2071 11.2928C23.15 12.2357 23.15 13.7643 22.2071 14.7072C19.9792 16.9351 17.7468 19.1587 15.5232 21.391C15.4241 21.4905 15.2993 21.6159 15.1511 21.7192C15.0223 21.809 14.8834 21.8834 14.7373 21.9407C14.5537 22.0127 14.3639 22.047 14.2211 22.0756L12.196 22.4806C11.8681 22.5461 11.5292 22.4435 11.2927 22.2071C11.0563 21.9706 10.9537 21.6317 11.0193 21.3038C11.1568 20.6166 11.2956 19.9296 11.4317 19.2421C11.459 19.1044 11.4933 18.9309 11.5593 18.7627C11.6166 18.6165 11.691 18.4777 11.7808 18.3489C11.8841 18.2007 12.0094 18.0759 12.1089 17.9768C14.3413 15.7532 16.5649 13.5208 18.7929 11.2929Z",
    fill: "#2D3B5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18099 14.1635C8.46324 14.3073 8.69271 14.5368 8.83652 14.819C8.98959 15.1194 9.00014 15.4476 9.00001 15.7769C9.00001 15.7847 9.00001 15.7924 9.00001 15.8C9.00001 17.2744 8.99947 18.7488 9.00001 20.2231C9.00006 20.3422 9.00011 20.4845 8.98987 20.6098C8.97801 20.755 8.94757 20.963 8.83652 21.181C8.69271 21.4632 8.46324 21.6927 8.18099 21.8365C7.96305 21.9476 7.75505 21.978 7.60984 21.9899C7.48452 22.0001 7.34226 22.0001 7.22315 22H2.77682C2.65755 22.0001 2.51498 22.0001 2.38936 21.9898C2.24364 21.9778 2.03523 21.9472 1.81695 21.8356C1.53435 21.6911 1.30428 21.46 1.16109 21.1767C1.05079 20.9585 1.02087 20.7506 1.0095 20.6046C0.999738 20.4791 1.00044 20.3369 1.00103 20.2185C1.00619 19.1792 0.975204 18.0653 1.38061 17.0866C1.88808 15.8614 2.86145 14.8881 4.08659 14.3806C4.59629 14.1695 5.13457 14.0819 5.74331 14.0404L7.22315 14C7.55241 13.9999 7.88058 14.0104 8.18099 14.1635Z",
    fill: "#2D3B5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5731 2.91551C14.7803 2.40358 15.3633 2.15657 15.8752 2.36379C17.7058 3.10478 19 4.90003 19 6.99997C19 9.09991 17.7058 10.8952 15.8752 11.6362C15.3633 11.8434 14.7803 11.5964 14.5731 11.0845C14.3658 10.5725 14.6129 9.9895 15.1248 9.78227C16.2261 9.33649 17 8.25741 17 6.99997C17 5.74253 16.2261 4.66345 15.1248 4.21767C14.6129 4.01044 14.3658 3.42745 14.5731 2.91551Z",
    fill: "#2D3B5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 7C4.5 4.23858 6.73857 2 9.5 2C12.2614 2 14.5 4.23858 14.5 7C14.5 9.76142 12.2614 12 9.5 12C6.73857 12 4.5 9.76142 4.5 7Z",
    fill: "#2D3B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharter);
export default __webpack_public_path__ + "static/media/charter.3100148aa5bdf79adae3e1ca3b7a1336.svg";
export { ForwardRef as ReactComponent };